import { makeAutoObservable } from "mobx";
import { DataTableStore } from "./DataTableStore";
import { onError } from "@/utils/onError";
import { SearchFilter } from "@/components/filters";
import { FiltersStore } from "./FiltersStore";
export class ManufacturersStore {
    constructor(manufacturerService) {
        this.manufacturerService = manufacturerService;
        this.loading = false;
        this.initializeManufacturerFilters = () => {
            const filterItems = [
                // Search Filter
                {
                    id: "search-filter",
                    Cmp: SearchFilter,
                    props: {
                        name: "search",
                        label: "Поиск",
                        placeholder: "Поиск по имени, email, телефону...",
                        allowClear: true,
                        showSearchIcon: true,
                        onChange: (value) => this.filtersStore.updateFilter("search", value),
                    },
                    visible: true,
                    order: 4,
                },
            ];
            this.filtersStore.setFilterItems(filterItems);
        };
        this.dataTable = new DataTableStore({
            defaultFilters: { search: "" },
            dataLoader: {
                loadData: (params) => this.loadManufacturers(params),
            },
        });
        this.filtersStore = new FiltersStore();
        this.initializeManufacturerFilters();
        makeAutoObservable(this);
    }
    setLoading(loading) {
        this.loading = loading;
    }
    async loadManufacturers(params) {
        try {
            // Получаем данные через сервис с учетом параметров
            const result = await this.manufacturerService.getManufacturersWithParams({
                page: params.page,
                pageSize: params.pageSize,
                filters: params.filters,
                sorters: params.sorters,
            });
            return {
                data: result.data,
                total: result.total,
                page: params.page,
                pageSize: params.pageSize,
            };
        }
        catch (error) {
            throw error;
        }
    }
    async deleteManufacturer(id) {
        this.setLoading(true);
        try {
            await this.manufacturerService.deleteManufacturer(id);
            await this.dataTable.refresh();
        }
        catch (error) {
            onError(error, "Error deleting manufacturer");
        }
        finally {
            this.setLoading(false);
        }
    }
}
